import React from 'react';
import { ReactionConfigContext } from './reaction-config-context';
export const useReactionConfig = () => React.useContext(ReactionConfigContext);
//# sourceMappingURL=use-reaction-config.js.map